import React, { useEffect, useState, useContext } from 'react';
import Header from './../elementos/basicos/Header';
import CabeceraCursos from '../elementos/basicos/Cabecera';
import Card from '../elementos/basicos/Card';
import ContenedorCards from '../elementos/basicos/ContenedorCards';
import Row from 'react-bootstrap/Row';
import Boton from '../elementos/eventos/Boton';
import Footer from '../elementos/basicos/Footer';
import { StyleSheetManager } from 'styled-components';
import CargaCards from '../elementos/eventos/CargaCards';
import { fetchCursosData} from './../../peticiones_API/Cursos_Ramdom';
import { CategoriasContext } from "../../peticiones_API/Peticiones_Categorias";



const CursosInicio = () => {
  const { categorias, cargaCat } = useContext(CategoriasContext);

  const [dataCurso, setDataCurso] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const cursosData = {}; 
  
        for (const cat of categorias) {
          const cursoResponse = await fetchCursosData(cat.urlCat);
  
          
          if (!cursosData[`${cat.Id}`]) {
            cursosData[`catId_${cat.Id}`] = [];
          }
  

          cursosData[`catId_${cat.Id}`] = cursoResponse.data;
        }
  
        // console.log("cursosData:", cursosData);
        setDataCurso(cursosData);
        setLoading(false);
      } catch (error) {
        console.error("Ha habido un error:", error);
      }
    };
  
    if (categorias.length > 0) {
      fetchData();
    }
  }, [categorias]);

  return (
    <>
      <Header />
      <StyleSheetManager shouldForwardProp={() => true}>
        <CabeceraCursos
          Titulo="CURSOS GRATUITOS"
          Subtitulo="(100% SUBVENCIONADOS)"
          Texto_1="Sea cual sea tu situación laboral, encuentra el curso que mejor se ajuste a tus necesidades."
          Texto_2="¡Plazas limitadas, no dejes pasar esta oportunidad!"
          color_cabecera="true"
        />
      </StyleSheetManager>

      {!cargaCat &&
        categorias.map((cat) => (
          <ContenedorCards key={cat.Id}>
            <h2>{cat.categoria}</h2>
            <Row className="justify-content-md-center">
              {loading ? <CargaCards alineado="true" /> : <Card elementosLista={dataCurso[`catId_${cat.Id}`]}  categoria={cat} />}
            </Row>

            {cat.SubCategoria.length > 0 ? (
              <Boton alineado="true" to={`/cursos/${cat.urlCat}/subcategorias`}>DESCUBRE MÁS CURSOS</Boton>
            ) : (
              <Boton alineado="true" to={`/cursos/${cat.urlCat}`}>DESCUBRE MÁS CURSOS</Boton>
            )}
          </ContenedorCards>
        ))}



      <Footer />
    </>
  );
}

export default CursosInicio;


